import { LOCALE } from '../AppConstants';

export const LOGIN_CHANNELS = { MLID: 'pwd', SSO: 'inbound-sso' };
export const ORIGINS = {
    MOBILE: 'mobile', // Native Mobile App
    WEB: 'web', // Web Browser (including desktop and mobile)
};

/**
 * List of valid keys in the ctx. Empty array indicates all values are valid for that key
 */
const VALID_VALUES = {
    channel: Object.values(LOGIN_CHANNELS),
    lang: [LOCALE.FR_NO_REGION, LOCALE.EN_NO_REGION],
    origin: Object.values(ORIGINS),
    entityId: [],
    selectedPlan: [],
    rsfId: [],
};

/**
 * @description
 * Checks if the provided ctx object is valid according to predefined rules.
 * This allows ctx to have extra fields, a subset of valid fields, or fields with flexible values, to
 * support extensibility and backwards compatibility
 * @param {Object} ctx - The ctx object to validate
 * @returns {boolean}
 */
export const isCtxValid = (ctx) => {
    return Object.entries(ctx).every(([key, value]) => {
        const validationRules = VALID_VALUES[key];

        if (!validationRules) {
            // If the key is not in VALID_VALUES (unknown properties), consider it valid
            return true;
        }

        const isValidValue = validationRules.includes(value);
        // Allow any string or null value if no specific allowed values are defined
        const anyValueIsAllowed = validationRules.length === 0 && (typeof value === 'string' || value === null);

        return isValidValue || anyValueIsAllowed;
    });
};

/**
 * @description Decode and validate the ctx.
 * @param {string} encodedCtx - The base64-encoded ctx.
 * @param {Object} logger
 * @returns {Object|null} - The decoded ctx or null if invalid.
 */
export const decodeCtx = (encodedCtx, logger) => {
    if (!encodedCtx) {
        logger.warn('Encoded ctx is missing.');
        return null;
    }

    try {
        logger.info(`Decoding ctx: ${encodedCtx}`);
        const decodedCtx = JSON.parse(atob(decodeURIComponent(encodedCtx)));
        const isValid = isCtxValid(decodedCtx);

        if (!isValid) {
            logger.error(`Ctx is invalid: ${JSON.stringify(decodedCtx)}`);
            return null;
        }
        return decodedCtx;
    } catch (e) {
        logger.error(`Failed to decode ctx: Reason: ${e}`);
        return null;
    }
};
